'use client';
import { Roboto } from 'next/font/google';
import { createTheme,  alpha, getContrastRatio } from '@mui/material/styles';

const roboto = Roboto({
  weight: ['300', '400', '500', '700'],
  subsets: ['latin'],
  display: 'swap',
});


export const getAppTheme = (mode = 'light') =>
  createTheme({
    typography: {
      fontFamily: roboto.style.fontFamily,
    },
    palette: {
      mode: mode,
      ...(mode === 'dark'
        ? {
            background: {
              default: '#0f172a', // slate-900 (softer dark)
              paper: '#1e293b',   // slate-800 (lighter card/surface)
            },
            text: {
              primary: '#f8fafc',
              secondary: '#cbd5e1',
            },
            divider: 'rgba(255, 255, 255, 0.16)',
          }
        : {
            background: {
              default: '#f8fafc',
              paper: '#ffffff',
            },
            text: {
              primary: '#0f172a',
              secondary: '#64748b',
            },
            divider: 'rgba(0, 0, 0, 0.08)',
          }),
      ochre: {
        main: '#E3D026',
        light: '#E9DB5D',
        dark: '#A29415',
        contrastText: '#242105',
      },
      violet: {
        main: alpha('#7F00FF', 0.7),
        light: alpha('#7F00FF', 0.5),
        dark: alpha('#7F00FF', 0.9),
        contrastText: getContrastRatio(alpha('#7F00FF', 0.7), '#fff') > 4.5 ? '#fff' : '#111',
      },
      green: {
        main: alpha('#2E7D32', 0.7),
        light: alpha('#2E7D32', 0.5),
        dark: alpha('#2E7D32', 0.9),
        contrastText: getContrastRatio('#2E7D32', '#fff') > 4.5 ? '#fff' : '#111',
      },
      darkGreen: {
        main: '#1b5e20',
        light: alpha('#1b5e20', 0.5),
        dark: alpha('#1b5e20', 0.9),
        contrastText: getContrastRatio('#1b5e20', '#fff') > 4.5 ? '#fff' : '#111',
      },
      lightGreen: {
        main: '#4caf50',
        light: alpha('#4caf50', 0.5),
        dark: alpha('#4caf50', 0.9),
        contrastText: '#fff',
      },
    },
  });

const theme = getAppTheme('light');

export default theme;